/** Loads signed packets for one customer (cif) or, with no cif, the most recent across customers. */
import { useEffect, useState } from 'react';
import type { SignedPacket } from '@retail-ops/shared-types';
import { useApiClient } from '@/contexts/ApiClientContext';

export function useSignedPackets(cif: string | null): { packets: SignedPacket[] | null; loading: boolean; error: string | null } {
  const client = useApiClient();
  const [state, setState] = useState<{ packets: SignedPacket[] | null; loading: boolean; error: string | null }>({ packets: null, loading: true, error: null });
  useEffect(() => {
    const ctrl = new AbortController();
    setState((s) => ({ ...s, loading: true, error: null }));
    const req = cif
      ? client.retail.carts.signedPacketsForCustomer(cif, { signal: ctrl.signal })
      : client.retail.carts.recentSignedPackets(20, { signal: ctrl.signal });
    req.then((r) => { if (!ctrl.signal.aborted) setState({ packets: r.packets ?? [], loading: false, error: null }); })
      .catch((e: unknown) => {
        if (!ctrl.signal.aborted) setState({ packets: null, loading: false, error: e instanceof Error ? e.message : 'Could not load signed packets.' });
      });
    return () => ctrl.abort();
  }, [client, cif]);
  return state;
}
